import React from 'react';
import { Main } from 'components/Main.js'

export const App = () => {
  return (
    <Main />
  );
}